/* Max Sports: storefront display translation. Canonical option values and prices stay unchanged. */
(() => {
  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  if (!['fr', 'zh'].includes(locale)) return;
  const translations = {
    'Free Stringing Service with String Add-On': ['Pose du cordage offerte avec l’achat d’un cordage', '购买球线可享免费穿线服务'],
    'String Tension': ['Tension du cordage (lb)', '穿线磅数（lb）'],
    'Replace factory string': ['Remplacer le cordage d’origine', '更换原厂球线'],
    'Replace Factory String': ['Remplacer le cordage d’origine', '更换原厂球线'],
    'Replace Factory String With Our Professional Stringing Service': ['Remplacer le cordage d’origine avec notre service professionnel', '使用专业穿线服务更换原厂球线'],
    'Keep Original String': ['Conserver le cordage d’origine', '保留原厂球线'],
    'String Tension (lb)': ['Tension du cordage (lb)', '穿线磅数（lb）'],
    'String Tension (lbs)': ['Tension du cordage (lb)', '穿线磅数（lb）'],
    'Stencil YONEX Logo': ['Logo YONEX sur le cordage', '球线印 YONEX 标志'],
    'Grip Add-On': ['Ajouter un grip', '加购手胶'],
    'Install the grip purchased': ['Poser le grip acheté', '安装所购手胶'],
    'Selections will add': ['Les options ajoutent', '所选附加服务将增加'],
    'to the price': ['au prix', ''],
    'No String': ['Sans cordage', '不穿线'],
    'None': ['Aucun', '不选'],
    'No': ['Non', '否'],
    'Yes': ['Oui', '是'],
    'Choose YONEX strings between durable, power and control strung by our professional stringers.': ['Choisissez un cordage YONEX selon vos besoins de durabilité, de puissance ou de contrôle. La pose est réalisée par nos spécialistes.', '根据耐用性、力量或控制需求选择 YONEX 球线，由我们的专业穿线师安装。'],
    'Stringing over recommended string tension will void warranty.': ['Une tension supérieure à la tension recommandée annule la garantie.', '超过建议穿线磅数将导致保修失效。'],
    'Strung over recommended string tension will void warranty.': ['Une tension supérieure à la tension recommandée annule la garantie.', '超过建议穿线磅数将导致保修失效。'],
    'Do not choose this option if not upgrading string as original string already has stencil on it.': ['Ne choisissez pas cette option si vous ne remplacez pas le cordage : le cordage d’origine porte déjà le logo.', '如果不更换球线，请勿选择此项，因为原厂球线已有印标。'],
    'This field is required': ['Ce champ est obligatoire', '此项必填']
  };
  const colors = {
    'Royal Blue':['bleu royal','宝蓝色'], 'Sky Blue':['bleu ciel','天蓝色'],
    'Lime Green':['vert citron','青柠绿'], 'Flash Red':['rouge vif','亮红色'],
    'Dark Gray':['gris foncé','深灰色'], 'Dark Grey':['gris foncé','深灰色'],
    'Silver Gray':['gris argenté','银灰色'], 'Silver Grey':['gris argenté','银灰色'],
    'Gold':['doré','金色'], 'Graphite':['graphite','石墨色'],
    'Turquoise':['turquoise','绿松石色'], 'Violet':['violet','紫罗兰色'],
    'Cobalt Blue':['bleu cobalt','钴蓝色'], 'Bright Purple':['violet vif','亮紫色'],
    'Bright Orange':['orange vif','亮橙色'], 'Iron Grey':['gris fer','铁灰色'],
    'Powder Green':['vert poudré','粉绿色'], 'Mist Pink':['rose brume','雾粉色'],
    'Pale Lilac':['lilas pâle','浅丁香紫'], 'Deep Purple':['violet foncé','深紫色'],
    'Citrus Green':['vert citron','柠檬绿色'], 'French Pink':['rose français','法式粉色'],
    'Wine Red':['bordeaux','酒红色'], 'White':['blanc','白色'], 'Black':['noir','黑色'],
    'Gray':['gris','灰色'], 'Grey':['gris','灰色'], 'Orange':['orange','橙色'],
    'Yellow':['jaune','黄色'], 'Purple':['violet','紫色'], 'Red':['rouge','红色'],
    'Green':['vert','绿色'], 'Blue':['bleu','蓝色'], 'Silver':['argent','银色'],
    'Mint':['menthe','薄荷色'], 'Pink':['rose','粉色']
  };
  const index = locale === 'fr' ? 0 : 1;
  const colorNames = Object.keys(colors).sort((a, b) => b.length - a.length);
  const colorLookup = new Map(colorNames.map(name => [name.toLowerCase(), colors[name]]));
  const colorPattern = new RegExp('\\b(' + colorNames.join('|') + ')\\b', 'gi');
  const original = new WeakMap();
  function translate(text, parent) {
    const key = text.trim();
    const labelKey = key.replace(/:$/, '');
    if (parent.matches('dt') && translations[labelKey]) return text.replace(labelKey, translations[labelKey][index]);
    if (translations[key]) return text.replace(key, translations[key][index]);
    if (parent.closest('option,.gpo-selected-values,.product-option dd')) {
      return text.replace(colorPattern, word => colorLookup.get(word.toLowerCase())[index])
        .replace(/\bDurability\b/g, locale === 'fr' ? 'Durabilité' : '耐用型')
        .replace(/\bRepulsion\b/g, locale === 'fr' ? 'Répulsion' : '高弹型')
        .replace(/\bControl\b/g, locale === 'fr' ? 'Contrôle' : '控制型')
        .replace(/3 Pack|3 Wraps/g, locale === 'fr' ? 'lot de 3' : '3 条装');
    }
    if (/^Selections will add .+ to the price$/.test(key)) {
      const amount = key.slice('Selections will add '.length, -' to the price'.length);
      return text.replace(key, locale === 'fr' ? 'Les options ajoutent ' + amount + ' au prix' : '所选附加服务将增加 ' + amount);
    }
    return text;
  }
  function update() {
    document.querySelectorAll('.gpo-app,.maxsports-choice-guide,.cart-item__details dl').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,textarea')) continue;
        const last = original.get(node);
        const source = last && node.nodeValue === last.output ? last.source : node.nodeValue;
        const output = translate(source, parent);
        original.set(node, {source, output});
        if (node.nodeValue !== output) node.nodeValue = output;
      }
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (!records.some(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return element?.closest('.gpo-app,.maxsports-choice-guide,.cart-item__details dl') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.gpo-app,.maxsports-choice-guide,.cart-item__details') || node.querySelector('.gpo-app,.maxsports-choice-guide,.cart-item__details')));
    })) return;
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    }
  });
  update();
  observer.observe(document.body, {childList:true, subtree:true, characterData:true});
})();

/* Locale-aware display only: Shopify amounts and option input values remain canonical. */
(() => {
  if (!(document.documentElement.lang || '').toLowerCase().startsWith('fr')) return;
  const script = document.querySelector('script[data-maxsports-currency]');
  const currency = script?.dataset.maxsportsCurrency;
  if (!['CAD', 'USD'].includes(currency)) return;
  const formatter = new Intl.NumberFormat('fr-CA', {style:'currency', currency, currencyDisplay:'code'});
  const scope = '.price-item,.cart-item__price-wrapper,.cart-item__totals,.cart-item__details > .product-option,.cart-item__old-price,.cart-item__final-price,.totals__total-value,.gpo-app';
  const seen = new WeakMap();
  function update() {
    document.querySelectorAll(scope).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea')) continue;
        const old = seen.get(node);
        const source = old && node.nodeValue === old.output ? old.source : node.nodeValue;
        const output = source.replace(/(?:CA\$|US\$|\$)\s*(\d{1,3}(?:,\d{3})*\.\d{2}|\d+\.\d{2})(?:\s*(?:CAD|USD))?/g,
          (_, amount) => formatter.format(Number(amount.replace(/,/g, ''))));
        seen.set(node, {source,output});
        if (node.nodeValue !== output) node.nodeValue = output;
      }
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (!records.some(r => {
      const e = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      return e?.closest(scope) || [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches(scope) || n.querySelector(scope)));
    })) return;
    if (!scheduled) { scheduled = true; requestAnimationFrame(() => {scheduled=false;update();}); }
  });
  update();
  observer.observe(document.body, {childList:true,subtree:true,characterData:true});
})();
